module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/search/search.component.scss
// module id = ./src/app/search/search.component.scss
// module chunks = main